import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';

import Icon from 'components/atoms/Icon';

const useStyles = makeStyles((theme) => ({
  currentStatusRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    '& > div': {
      textAlign: 'center',
    },
    '&.excel > div': {
      width: 21,
      height: 21,
    },
    '&.useMinHeight': {
      minHeight: 400,
    },
  },
  progressRoot: {
    display: 'block',
    width: 30,
    height: 30,
    margin: '0 auto !important',
  },
}));

const CurrentStatus = (props) => {
  const {
    children,
    type = 'loading',
    option,
    useMessage = true,
    ...rest
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  // type = loading, table, excel, moreLoading, noTable
  return (
    <div
      className={clsx(
        classes.currentStatusRoot,
        (type === 'noTable' || option === 'useMinHeight') && 'useMinHeight',
        type === 'excel' && 'excel',
        type === 'moreLoading' && 'moreLoading'
      )}
    >
      {type === 'noTable' ? (
        <div>
          <Icon
            icon="faTable"
            size={'4x'}
            color={theme.palette.primary.main}
            style={{ opacity: '.8' }}
          />
          <p style={{ marginBottom: 0 }}>
            {t('필터를 선택하여 테이블을 활성화하세요.')}
          </p>
        </div>
      ) : type === 'noData' || type === 'error' ? (
        <div className={classes.itemBox}>
          <WarningIcon
            color={type === 'noData' ? undefined : 'error'}
            fontSize="large"
          />
          {useMessage && (
            <>{type === 'noData' ? <div>No Data</div> : <div>Error</div>}</>
          )}
        </div>
      ) : (
        <CircularProgress
          classes={{
            root: classes.progressRoot,
          }}
          size="20"
          {...rest}
        />
      )}
    </div>
  );
};

export default CurrentStatus;
